import BUILD_ENV from '#client/build-env';

const ENV = {
  ...BUILD_ENV,
  ...window.ENV
};

export const {
  DEPLOY_ENV
} = ENV;

export default ENV;
